import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

//  import * as webapi from '../../assets/js/webproperty.js';
@Injectable()
export class DashboardService {
    city: any;
    hasCreateAccess = true;
    hasEditAccess = true;
    hasDeleteAccess = true;
    private headers = new Headers({'Content-Type': 'application/json'});
    private GetTariffDetails = webapi + 'dashboard/gettariffdetails/';
    private GetAppoinmentDetailsByDoctor = webapi + 'dashboard/getappoinmentdetailsbydoctor/';
    private GetVisitDetailsByDepartment = webapi + 'dashboard/getvisitdetailsbydepartment/';
    private GetBillingDetails = webapi + 'dashboard/getbillingdetails/';
    private GetCollectionType = webapi + 'dashboard/getCollectionType/';
    private GetCollectionSum = webapi + 'dashboard/getCollectionSum/';
    private GetCollectionTypeAndSum = webapi + 'dashboard/getcollectiontypeandsum/';
    private GetDepartmentWiseServiceReport = webapi + 'dashboard/getdepartmentwisseervicereport/';
    private GetTariffList = webapi + 'dashboard/gettarifflist?';
    private GetPharmacyBillingDeatils = webapi + 'dashboard/getpharmacybillingdetails/';
    private GetCurrency = webapi + 'dashboard/getcurrency?';
    private GetOverallBillingSummery = webapi + 'dashboard/getoverallbillingsummery/';
    private GetEMRDetails = webapi + 'dashboard/getemrdetails/';
    private GetPATDetails = webapi + 'dashboard/getpatdetails/';
    private GetRadiologyDeatils = webapi + 'dashboard/getRadiologyDetails?';
    private GetPathologyDeatils = webapi + 'dashboard/getPathologyDetails/';
    private GetPharmacyCollectionTypeAndSum = webapi + 'dashboard/getpharmacytypeandsum/';
    private GetActivityPatientCount = webapi + 'dashboard/getActivityPatientCount/';
    private GetQueueDetailsByUnit = webapi + 'dashboard/getQueueDetailsByUnit/';
    private Discharge = webapi + 'dashboard/getAdmissionAndDischargeCountDetails/';
    private RevenueDetails = webapi + 'dashboard/RevenueDetails/';
    private getopdlistofregistrationreport = webapi + 'mis_Opd-Registration-Report/getopdlistofregDashbord';
    constructor(private http: Http) {
    }

    getTariffDetails(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetTariffDetails + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDischargeSummary(){
        return this.http.get(this.Discharge)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRevenueDetails(){
        return this.http.get(this.RevenueDetails)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAppoinmentDetailsByDoctor(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetAppoinmentDetailsByDoctor + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitDetailsByDepartment(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetVisitDetailsByDepartment + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getBillingDetails(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetBillingDetails + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCollectionType(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetCollectionType + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCollectionsum(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetCollectionSum + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCollectionTypeAndSum(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetCollectionTypeAndSum + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDepartmentWiseServiceReport(unitid: any, tariff: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetDepartmentWiseServiceReport + unitid + '/' + tariff + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getTariffList(): Promise<any> {
        return this.http.post(this.GetTariffList, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacyBillingDeatils(unitid: any, unitlistid: any): Promise<any> {
        // console.log(this.GetPharmacyBillingDeatils + unitid+'/'+unitlistid)
        return this.http.get(this.GetPharmacyBillingDeatils + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCurrency(): Promise<any> {
        return this.http.post(this.GetCurrency, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getOverallBillingSummery(unit: any, tariff: any, serachType: any, count: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetOverallBillingSummery + unit + '/' + tariff + '/' + serachType + '/' + count + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getEMRDetails(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetEMRDetails + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPATDetails(unitid: any, unitlistid: any): Promise<any> {
        console.log('GetPATDetails in service', unitlistid);
        return this.http.get(this.GetPATDetails + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRadiologyDeatils(search_query: any): Promise<any> {
        return this.http.post(this.GetRadiologyDeatils, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPathologyDeatils(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetPathologyDeatils + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacyCollectionTypeAndSum(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetPharmacyCollectionTypeAndSum + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getActivityPatientCount(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetActivityPatientCount + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getQueueDetailsByUnit(unitid: any, unitlistid: any): Promise<any> {
        return this.http.get(this.GetQueueDetailsByUnit + unitid + '/' + unitlistid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getOpdListofRegistrationReport(fromdate: any,todate: any,limit: any, offset: any) {
        return this.http.post(this.getopdlistofregistrationreport + '/' + fromdate + '/' + todate + '/' + limit + '/' + offset,{headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/dashboard/dashboard.service.ts